__turbopack_context__.v({
  "body": "t1vigG_body",
  "deleteBtn": "t1vigG_deleteBtn",
  "row": "t1vigG_row",
});
